import { render, staticRenderFns } from "./products-list-page.vue?vue&type=template&id=00882830&"
import script from "./products-list-page.vue?vue&type=script&lang=js&"
export * from "./products-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports